import { Flex, FlexProps } from '@mantine/core'

const ChartFlexSection = (props: FlexProps) => {
    return (
        <Flex direction='column' gap='sm' mb='lg' {...props}>
            {props.children}
        </Flex>
    )
}

export default ChartFlexSection
